import { parseSavedPatterns } from '@aytm/app/stats/page/question-views/vq/lib/parse-saved-patterns'
import { calcDependableRefs } from '@aytm/app/stats/page/question-views/vq/lib/dependable-refs'
import { calcLogicData } from '@aytm/app/stats/page/question-views/vq/lib/logic-data'

// Everything a folded Virtual question's editor would have reported from its rows -- the questions
// it depends on and the codes it uses -- worked out from one parse of its saved patterns.
export const calcSavedPatternData = args => {
  const parsed = parseSavedPatterns(args)

  return {
    refs: calcDependableRefs({ ...args, parsed }),
    logicData: calcLogicData({ ...args, parsed })
  }
}
